import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import translate from '../../commonComponents/translate';
import SurveyDetails from './SurveyDetails';

function SurveyWrapper({ t, surveyId, contextId, backURL }) {
  const [survey, setSurvey] = useState(null);
  const getSurvey = () => new Promise((resolve, reject) => {
    axios.get(
      `/api/survey/${surveyId}`,
      {
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        },
      })
      .then(({ data: response }) => resolve(response.data))
      .catch(err => {
        console.log(err);
        reject(err);
      });
  });
  const getSurveyQuestions = () => new Promise((resolve, reject) => {
    axios.get(
      `/api/survey/${surveyId}/questions`,
      {
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        },
      })
      .then(({ data: response }) => resolve(response.data))
      .catch(err => {
        console.log(err);
        reject(err);
      });
  });
  const fetchSurvey = () => {
    const requests = [
      getSurvey(),
      getSurveyQuestions(),
    ];
    Promise.all(requests)
      .then(([surveyRequest, questions]) => {
        setSurvey({ ...surveyRequest, questions });
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchSurvey();
  }, []);
  return (
    <Title title={t('survey_head_title')}>
      <ContentContainer>
        <SubHeader title={t('survey_title', survey?.title ? survey.title : '')} />
        <div className="m-content journey-m-content">
          <div className="row full-page-container-with-subheader">
            <div className="col-lg-12">
              {survey && <SurveyDetails survey={survey} contextId={contextId} backURL={backURL} />}
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

SurveyWrapper.propTypes = {
  t: PropTypes.func.isRequired,
  surveyId: PropTypes.string.isRequired,
  contextId: PropTypes.string,
  backURL: PropTypes.string,
};

SurveyWrapper.defaultProps = {
  contextId: null,
  backURL: null,
};

export default translate(SurveyWrapper);
